import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/components/login'
// import Choose from '@/components/choose'
import Boss from '@/views/'
import homePage from '@/views/home/homePage.vue'
import paymentAnalysis from '@/views/home/paymentAnalysis.vue'
import customerAnalysis from '@/views/home/customerAnalysis.vue'
import accountingAnalysis from '@/views/home/accountingAnalysis.vue'
import Supper from '@/views/supper/supperService.vue'
import revenueAnalysis from '@/views/analysis/revenueAnalysis.vue'
import fullAnalysis from '@/views/analysis/fullAnalysis.vue'
import eventAnalysis from '@/views/analysis/eventAnalysis.vue'
import proMain from '@/views/proManage/proMain.vue'
import editMain from '@/views/proManage/editProMain.vue'
import addMain from '@/views/proManage/addProMain.vue'
import productTypeManage from '@/views/proManage/productType.vue'
import abilityModiHistory from '@/views/proManage/viewingHistory.vue'
import pathManage from '@/views/proManage/pathManage.vue'
import valuationStrategy from '@/views/valuation/valuationStrategy.vue'
import paymentRecord from '@/views/pay/paymentRecord.vue'
import supplierDetail from '@/views/rechargeManagement/supplierDetail.vue'
import customerDetail from '@/views/rechargeManagement/customerDetail.vue'
import supplierAccount from '@/views/accountManagement/supplierAccount.vue'
import customerAccount from '@/views/accountManagement/customerAccount.vue'
import cusBalance from '@/views/accountManagement/cusBalance.vue'
import supplierSettlement from '@/views/settleManagement/supplierSettlement.vue'
import customerSettlement from '@/views/settleManagement/customerSettlement.vue'
import kinderSettlement from '@/views/settleManagement/kinderSettlement.vue'
import supplierBill from '@/views/billManagement/supplierBill.vue'
import customerBill from '@/views/billManagement/customerBill.vue'
import kinderBill from '@/views/billManagement/kinderBill.vue'
import historyOfSupplier from '@/views/accountHistory/historyOfSupplier.vue'
import historyOfCustomer from '@/views/accountHistory/historyOfCustomer.vue'
import historyOfKinder from '@/views/accountHistory/historyOfKinder.vue'
import supplierAccounting from '@/views/accounting/supplierAccounting.vue'
import customerAccounting from '@/views/accounting/customerAccounting.vue'
import kinderAccounting from '@/views/accounting/kinderAccounting.vue'
import customerType from '@/views/customerManagement/customerType.vue'
import productAdjust from '@/views/customerManagement/productAdjust.vue'
import batchManagement from '@/views/reconciliationManagement/batchManagement.vue'
import detailManagement from '@/views/reconciliationManagement/detailManagement.vue'
import errorHandling from '@/views/reconciliationManagement/errorHandling.vue'
import interfaceParams from '@/views/config/interfaceParams.vue'
import timedTaskManagement from '@/views/timedTask/timedTaskManagement.vue'
import executionRecord from '@/views/timedTask/executionRecord.vue'
import objectManagement from '@/views/warning/objectManagement.vue'
import recordManagement from '@/views/warning/recordManagement.vue'
import typeWarn from '@/views/warning/typeWarn.vue'
import ruleManagement from '@/views/warning/ruleManagement.vue'
import maintenance from '@/views/supper/maintenance.vue'
import editMaintenance from '@/views/supper/editMaintenance.vue'
import addMaintenance from '@/views/supper/addMaintenance.vue'
import customerInfor from '@/views/customerManagement/customerInfor.vue'
import personCusInfo from '@/views/customerManagement/personCusInfo.vue'
import distributorInfo from '@/views/customerManagement/distributorInfo.vue'
import editCustomerInfor from '@/views/customerManagement/editCustomerInfor.vue'
import addCustomerInfor from '@/views/customerManagement/addCustomerInfor.vue'
import editPersonCusInfo from '@/views/customerManagement/editPersonCusInfo.vue'
import addPersonCusInfo from '@/views/customerManagement/addPersonCusInfo.vue'
import customerProductManage from '@/views/customerManagement/customerProductManage.vue'
import customerProductModifyPrice from '@/views/customerManagement/customerProductModifyPrice.vue'
import valuationRule from '@/views/valuation/valuationRule.vue'
import detailRule from '@/views/valuation/detailRule.vue'
import ruleManage from '@/views/valuation/ruleManage.vue'
import ruleEditManage from '@/views/valuation/ruleEditManage.vue'
import ruleCopeManage from '@/views/valuation/ruleCopeManage.vue'
import customerInforDetails from '@/views/customerManagement/customerInforDetails.vue'
import personDetail from '@/views/customerManagement/personDetail.vue'
import maintenanceDetails from '@/views/supper/maintenanceDetails.vue'
import refundRecord from '@/views/refund/refundRecord.vue'
import homeManagement from '@/views/home/homeManagement.vue'
import hardwarePro from '@/views/proManage/hardwarePro.vue'
import brandModel from '@/views/brandManagement/brandModel.vue'
import supContract from '@/views/contractManagement/supContract.vue'
import cusContract from '@/views/contractManagement/cusContract.vue'
import cusOrder from '@/views/cusOrderManagement/cusOrder.vue'
import userOrder from '@/views/cusOrderManagement/userOrder.vue'
import registeredUser from '@/views/userManagement/registeredUser.vue'
import userJournal from '@/views/userManagement/userJournal.vue'
import verificationCode from '@/views/userManagement/verificationCode.vue'
import codeRule from '@/views/userManagement/codeRule.vue'
import userCodeManager from '@/views/userManagement/userCodeManager.vue'
import informationChannel from '@/views/notificationCenter/informationChannel.vue'
import informationHistory from '@/views/notificationCenter/informationHistory.vue'
import consumeFiled from '@/views/config/consumeFiled.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login
    // },
    // {
    //   path: '/choose',
    //   name: 'Choose',
    //   component: Choose
    // },
    {
      path: '/Boss',
      name: 'Boss',
      // redirect: '/homePage',
      component: Boss,
      children: [
        {
          path: '/interface',
          name: 'Supper',
          component: Supper,
          meta: { title: '服务管理' }
        },
        {
          path: '/homePage',
          name: 'homePage',
          component: homePage,
          meta: { title: '首页' }
        },
        {
          path: '/codeRule',
          name: 'codeRule',
          component: codeRule,
          meta: { title: '验证码规则管理' }
        },
        {
          path: '/userCodeManager',
          name: 'userCodeManager',
          component: userCodeManager,
          meta: { title: '验证码功能锁定' }
        },
        {
          path: '/registeredUser',
          name: 'registeredUser',
          component: registeredUser,
          meta: { title: '注册用户信息' }
        },
        {
          path: '/informationHistory',
          name: 'informationHistory',
          component: informationHistory,
          meta: { title: '消息发送历史' }
        },
        {
          path: '/informationChannel',
          name: 'informationChannel',
          component: informationChannel,
          meta: { title: '消息渠道管理' }
        },
        {
          path: '/consumeFiled',
          name: 'consumeFiled',
          component: consumeFiled,
          meta: { title: '下游计费字段' }
        },
        {
          path: '/verificationCode',
          name: 'verificationCode',
          component: verificationCode,
          meta: { title: '验证码发送历史' }
        },
        {
          path: '/userJournal',
          name: 'userJournal',
          component: userJournal,
          meta: { title: '注册用户操作日志' }
        },
        {
          path: '/homeManagement',
          name: 'homeManagement',
          component: homeManagement,
          meta: { title: '首页管理' }
        },
        {
          path: '/personCusInfo',
          name: 'personCusInfo',
          component: personCusInfo,
          meta: { title: '个人客户信息' }
        },
        {
          path: '/cusOrder',
          name: 'cusOrder',
          component: cusOrder,
          meta: { title: '客户订单管理' }
        },
        {
          path: '/userOrder',
          name: 'userOrder',
          component: userOrder,
          meta: { title: '用户订单管理' }
        },
        {
          path: '/supContract',
          name: 'supContract',
          component: supContract,
          meta: { title: '供应商合同管理' }
        },
        {
          path: '/cusContract',
          name: 'cusContract',
          component: cusContract,
          meta: { title: '客户合同管理' }
        },
        {
          path: '/distributorInfo',
          name: 'distributorInfo',
          component: distributorInfo,
          meta: { title: '经销商信息' }
        },
        {
          path: '/addPersonCusInfo',
          name: 'addPersonCusInfo',
          component: addPersonCusInfo,
          meta: { title: '新增个人客户信息' }
        },
        {
          path: '/editPersonCusInfo',
          name: 'editPersonCusInfo',
          component: editPersonCusInfo,
          meta: { title: '编辑个人客户信息' }
        },
        {
          path: '/personDetail',
          name: 'personDetail',
          component: personDetail,
          meta: { title: '个人客户信息详情' }
        },
        {
          path: '/hardwarePro',
          name: 'hardwarePro',
          component: hardwarePro,
          meta: { title: '硬件产品管理' }
        },
        {
          path: '/brandModel',
          name: 'brandModel',
          component: brandModel,
          meta: { title: '品牌型号管理' }
        },
        {
          path: '/paymentAnalysis',
          name: 'paymentAnalysis',
          component: paymentAnalysis,
          meta: { title: '支付分析' }
        },
        {
          path: '/customerAnalysis',
          name: 'customerAnalysis',
          component: customerAnalysis,
          meta: { title: 'CRM客户分析' }
        },
        {
          path: '/accountingAnalysis',
          name: 'accountingAnalysis',
          component: accountingAnalysis,
          meta: { title: '账务分析' }
        },
        {
          path: '/revenueMarket',
          name: 'revenueMarket',
          component: revenueAnalysis,
          meta: {
            title: '营收大盘',
            keepAlive: true
          }
        },
        {
          path: '/fullAnalysis',
          name: 'fullAnalysis',
          component: fullAnalysis,
          meta: {
            title: '整体分析',
            keepAlive: true
          }
        },
        {
          path: '/eventAnalysis',
          name: 'eventAnalysis',
          component: eventAnalysis,
          meta: {
            title: '事件分析',
            keepAlive: true
          }
        },
        {
          path: '/editAbilityManage',
          name: 'editMain',
          component: editMain,
          meta: {
            title: '编辑云端产品',
            keepAlive: true
          }
        },
        {
          path: '/addAbilityManage',
          name: 'addProMain',
          component: addMain,
          meta: {
            title: '新增云端产品',
            keepAlive: true
          }
        },
        {
          path: '/productTypeManage',
          name: 'productTypeManage',
          component: productTypeManage,
          meta: { title: '产品类型管理' }
        },
        {
          path: '/cusBalance',
          name: 'cusBalance',
          component: cusBalance,
          meta: { title: '客户余额快照' }
        },
        {
          path: '/abilityModiHistory',
          name: 'abilityModiHistory',
          component: abilityModiHistory,
          meta: { title: '查看历史' }
        },
        {
          path: '/abilityManage',
          name: 'proMain',
          component: proMain,
          meta: { title: '云端产品管理' }
        },
        {
          path: '/paymentRecord',
          name: 'paymentRecord',
          component: paymentRecord,
          meta: { title: '支付记录管理' }
        },
        {
          path: '/recharge',
          name: 'supplierDetail',
          component: supplierDetail,
          meta: { title: '供应商充值明细' }
        },
        {
          path: '/cusRecharge',
          name: 'customerDetail',
          component: customerDetail,
          meta: { title: '客户充值明细' }
        },
        {
          path: '/supplierAccount',
          name: 'supplierAccount',
          component: supplierAccount,
          meta: { title: '供应商账户管理' }
        },
        {
          path: '/customerAccount',
          name: 'customerAccount',
          component: customerAccount,
          meta: { title: '客户账户管理' }
        },
        {
          path: '/supplierSettlement',
          name: 'supplierSettlement',
          component: supplierSettlement,
          meta: { title: '供应商明结算单' }
        },
        {
          path: '/customerSettlement',
          name: 'customerSettlement',
          component: customerSettlement,
          meta: { title: '客户结算单' }
        },
        {
          path: '/kinderSettlement',
          name: 'kinderSettlement',
          component: kinderSettlement,
          meta: { title: '支付结算单' }
        },
        {
          path: '/supplierBill',
          name: 'supplierBill',
          component: supplierBill,
          meta: { title: '供应商明细账单' }
        },
        {
          path: '/customerBill',
          name: 'customerBill',
          component: customerBill,
          meta: { title: '客户明细账单' }
        },
        {
          path: '/kinderBill',
          name: 'kinderBill',
          component: kinderBill,
          meta: { title: '支付明细账单' }
        },
        {
          path: '/historyOfSupplier',
          name: 'historyOfSupplier',
          component: historyOfSupplier,
          meta: { title: '供应商调账历史' }
        },
        {
          path: '/historyOfCustomer',
          name: 'historyOfCustomer',
          component: historyOfCustomer,
          meta: { title: '客户调账历史' }
        },
        {
          path: '/historyOfKinder',
          name: 'historyOfKinder',
          component: historyOfKinder,
          meta: { title: '支付调账历史' }
        },
        {
          path: '/supplierList',
          name: 'supplierList',
          component: supplierAccounting,
          meta: { title: '供应商核算单' }
        },
        {
          path: '/customerList',
          name: 'customerList',
          component: customerAccounting,
          meta: { title: '客户核算单' }
        },
        {
          path: '/kinderList',
          name: 'kinderList',
          component: kinderAccounting,
          meta: { title: '支付核算单' }
        },
        {
          path: '/customerType',
          name: 'customerType',
          component: customerType,
          meta: { title: '客户类型管理' }
        },
        {
          path: '/batchManagement',
          name: 'batchManagement',
          component: batchManagement,
          meta: { title: '对账批次管理' }
        },
        {
          path: '/errorHandling',
          name: 'errorHandling',
          component: errorHandling,
          meta: { title: '差错处理管理' }
        },
        {
          path: '/detailManagement',
          name: 'detailManagement',
          component: detailManagement,
          meta: { title: '对账明细管理' }
        },
        {
          path: '/productPricingManagement',
          name: 'productPricingManagement',
          component: productAdjust,
          meta: { title: '产品调价管理' }
        },
        {
          path: '/valuationStrategy',
          name: 'valuationStrategy',
          component: valuationStrategy,
          meta: { title: '计价策略' }
        },
        {
          path: '/interfaceParams',
          name: 'interfaceParams',
          component: interfaceParams,
          meta: { title: '配置管理' }
        },
        {
          path: '/pathManage',
          name: 'pathManage',
          component: pathManage,
          meta: { title: '通道管理' }
        },
        {
          path: '/timedTaskManagement',
          name: 'timedTaskManagement',
          component: timedTaskManagement,
          meta: { title: '定时任务管理' }
        },
        {
          path: '/executionRecord',
          name: 'executionRecord',
          component: executionRecord,
          meta: { title: '执行记录' }
        },
        {
          path: '/objectManagement',
          name: 'objectManagement',
          component: objectManagement,
          meta: { title: '预警对象管理' }
        },
        {
          path: '/ruleManagement',
          name: 'ruleManagement',
          component: ruleManagement,
          meta: { title: '预警规则管理' }
        },
        {
          path: '/recordManagement',
          name: 'recordManagement',
          component: recordManagement,
          meta: { title: '预警记录管理' }
        },
        {
          path: '/typeWarn',
          name: 'typeWarn',
          component: typeWarn,
          meta: { title: '预警类型管理' }
        },
        {
          path: '/maintenance',
          name: 'maintenance',
          component: maintenance,
          meta: {
            title: '供应商档案'
          }
        },
        {
          path: '/addMaintenance',
          name: 'addMaintenance',
          component: editMaintenance,
          meta: {
            title: '供应商档案新增'
          }
        },
        {
          path: '/editMaintenance',
          name: 'editMaintenance',
          component: addMaintenance,
          meta: {
            title: '供应商档案编辑',
            keepAlive: true
          }
        },
        {
          path: '/customerInfor',
          name: 'customerInfor',
          component: customerInfor,
          meta: { title: '企业客户信息管理' }
        },
        {
          path: '/addCustomerInfor',
          name: 'addCustomerInfor',
          component: editCustomerInfor,
          meta: {
            title: '新增企业客户信息',
            keepAlive: true
          }
        },
        {
          path: '/editCustomerInfor',
          name: 'editCustomerInfor',
          component: addCustomerInfor,
          meta: {
            title: '编辑企业客户信息',
            keepAlive: true
          }
        },
        {
          path: '/customerProductManage',
          name: 'customerProductManage',
          component: customerProductManage,
          meta: { title: '客户产品管理' }
        },
        {
          path: '/customerProductModifyPrice',
          name: 'customerProductModifyPrice',
          component: customerProductModifyPrice,
          meta: {
            title: '客户产品调价',
            keepAlive: true
          }
        },
        {
          path: '/valuationRule',
          name: 'valuationRule',
          component: valuationRule,
          meta: { title: '计价规则' }
        },
        {
          path: '/detailRule',
          name: '计价规则详情',
          component: detailRule,
          meta: {
            title: '计价规则详情',
            keepAlive: true
          }
        },
        {
          path: '/addRule',
          name: 'addRule',
          component: ruleManage,
          meta: {
            title: '新增计价规则',
            keepAlive: true
          }
        },
        {
          path: '/editRule',
          name: 'editRule',
          component: ruleEditManage,
          meta: {
            title: '编辑计价规则',
            keepAlive: true
          }
        },
        {
          path: '/copyRule',
          name: 'copyRule',
          component: ruleCopeManage,
          meta: {
            title: '复制计价规则'
          }
        },
        {
          path: '/maintenanceDetails',
          name: '供应商信息详情',
          component: maintenanceDetails,
          meta: {
            title: '供应商信息详情',
            keepAlive: true
          }
        },
        {
          path: '/customerInforDetails',
          name: '企业客户信息详情',
          component: customerInforDetails,
          meta: {
            title: '企业客户信息详情',
            keepAlive: true
          }
        },
        {
          path: '/refundRecord',
          name: 'refundRecord',
          component: refundRecord,
          meta: { title: '退款记录管理' }
        }
      ]
    },
    {
      path: '*',
      redirect: '/Boss'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js